export default __webpack_public_path__ + "static/hlederer-b54c257adfb1831daa234860acf203b2.jpg";